import { render, staticRenderFns } from "./KanbanBoardTaskList.vue?vue&type=template&id=f092107a"
import script from "./KanbanBoardTaskList.vue?vue&type=script&lang=js"
export * from "./KanbanBoardTaskList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports